import React, {Component} from 'react';
import Chip from '@material-ui/core/Chip';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dropdown from '../../../components/dropdown';

class SchemaSideSelector extends Component {
  render() {
    const {
      label, connections, selectedConnId, schemas, selectedSchema,
      engine, onConnectionChange, onSchemaChange, schemasLoading, side,
      sourceKind, ddSchemas, selectedDdSchemaId, onKindChange, onDdSchemaChange,
    } = this.props;

    const connItems = (connections || []).map((c) => ({
      name: c.connectionName || c.name || c.db_connection_name || String(c.connId),
      value: c.connId || c.id || c.idconnectiondetail,
    }));

    const schemaItems = (schemas || []).map((s) => ({name: s.name, value: s.name}));

    const ddSchemaItems = (ddSchemas || []).map((s) => ({
      name: `${s.instanceName} / ${s.schemaName}`,
      value: s.schemaId,
    }));

    return (
      <div className="sc-side-selector">
        <div className="sc-side-label">{label}</div>
        <RadioGroup
          row
          value={sourceKind || 'live'}
          onChange={(e) => onKindChange && onKindChange(e.target.value)}
          className="sc-sourcetype-toggle"
          data-testid={`sc-sourcetype-${side}`}
        >
          <FormControlLabel
            value="live"
            control={<Radio size="small" inputProps={{'data-testid': `sc-sourcetype-${side}-live`}} />}
            label="Live"
          />
          <FormControlLabel
            value="dd"
            control={<Radio size="small" inputProps={{'data-testid': `sc-sourcetype-${side}-dd`}} />}
            label="Data Dictionary"
          />
        </RadioGroup>

        {(sourceKind || 'live') === 'live' ? (
          <>
            <Dropdown
              label="Connection"
              value={selectedConnId || null}
              items={connItems}
              onChange={onConnectionChange}
              fullWidth
              inputProps={{'data-testid': `sc-conn-select-${side}`}}
            />
            <Dropdown
              label={schemasLoading ? 'Loading schemas…' : 'Schema'}
              value={selectedSchema || null}
              items={schemaItems}
              onChange={onSchemaChange}
              fullWidth
              inputProps={{'data-testid': `sc-schema-select-${side}`}}
            />
          </>
        ) : (
          <Dropdown
            label="Data Dictionary schema"
            value={selectedDdSchemaId || null}
            items={ddSchemaItems}
            onChange={onDdSchemaChange}
            fullWidth
            inputProps={{'data-testid': `sc-dd-schema-select-${side}`}}
          />
        )}

        {engine && (
          <Chip
            label={engine}
            size="small"
            className="sc-engine-chip"
            data-testid={`sc-engine-chip-${side}`}
          />
        )}
      </div>
    );
  }
}

export default SchemaSideSelector;
